import React from "react";

export const BtnNewsLetter = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none">
      <path
        d="M14.7596 1.23313C14.7596 1.03885 14.6021 0.881348 14.4078 0.881348H11.2417C11.0475 0.881348 10.89 1.03885 10.89 1.23313C10.89 1.42742 11.0475 1.58492 11.2417 1.58492H14.056V4.39918C14.056 4.59347 14.2135 4.75097 14.4078 4.75097C14.6021 4.75097 14.7596 4.59347 14.7596 4.39918V1.23313ZM1.31146 14.8269L14.6565 1.48188L14.159 0.984383L0.813965 14.3295L1.31146 14.8269Z"
        fill="white"
      />
    </svg>
  );
};
